<template>
  <div class="text-divider">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppTextDivider',
})
</script>

<style lang="scss" scoped>
.text-divider {
  --text-divider-gap: 8px;
  align-items: center;
  color: rgb(var(--v-theme-grey-500));
  display: flex;
}

.text-divider::before, .text-divider::after {
  content: '';
  height: 1px;
  background-color: rgb(var(--v-theme-grey-100));
  flex-grow: 1;
}

.text-divider::before {
  margin-right: var(--text-divider-gap);
}

.text-divider::after {
  margin-left: var(--text-divider-gap);
}
</style>
